<template>
  <div>
    <fast-answer-box @select="onFastAnswerSelect" />
    <div class="box-footer chat-input-section p-3 p-lg-4 border-top mb-0">
      <attach-box
        :attachment="message.attachment"
        @select="selectAttach"
      />

      <div class="textarea-overlay">
        <textarea
          ref="message_payload"
          v-model="message.payload"
          :placeholder="$t('room.footer.text_placeholder')"
          class="form-control form-control-lg bg-light border-light rounded overflow-auto"
          :style="{height: messagePayloadHeight}"
          @keydown="handleKeyDown"
        />
      </div>

      <div class="icon-textarea">
        <button
          type="submit"
          class="btn font-size-16 btn-lg chat-send"
          :class="{ 'send-disabled': inputDisabled }"
          @click="submitText"
        >
          <i
            class="ri-send-plane-2-fill"
            :param="inputDisabled ? 'disabled' : ''"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import throttle from "lodash.throttle";
import ServiceChat from "../../../services/chat";
import FastAnswerBox from "./FastAnswerFooterRoomComponents";
import AttachBox from "./Attach/BtnAttachFooterRoomComponents";

const defaultHeight = 22;
const maxHeight = 4 * defaultHeight;

export default {
  name: 'RoomFooterForm',
  components: {
    FastAnswerBox,
    AttachBox,
  },
  data: () => ({
    inputDisabled: false,
    messagePayloadHeight: defaultHeight + "px",

    sending: false,
    is_attach_image: false,
    uniq_seq: '',
    message: {
      payload: '',
      attachment: {
        type: 'image',
        url: '',
        url_thumbnail: undefined,
        duration: undefined,
        size: undefined,
        filename: 'image.jpg',
      },
    },
  }),
  computed: {
    ...mapState('rooms', ['selectedRoomId']),
  },
  watch: {
    selectedRoomId() {
      this.resetMessage();
    },
    'message.payload'(value) {
      let matchEnter = (value.match(/\n/g) || []).length;
      let scrollHeight = (1 + matchEnter) * defaultHeight;
      if (scrollHeight > maxHeight) scrollHeight = maxHeight;

      this.messagePayloadHeight = scrollHeight + "px";

      this.onType();
    },
  },
  mounted() {
    this.$refs.message_payload.focus();
  },
  methods: {
    onFastAnswerSelect(payload) {
      this.message.payload = payload;
    },
    resetMessage() {
      this.message.payload = '';
    },
    handleKeyDown(event) {
      if ((event.key === 'Enter' && !event.shiftKey) === false) return;

      this.submitText();
      event.preventDefault();
    },
    onType() {
      this.onTypeDebounce();
    },
    onTypeDebounce: throttle(function () {
      ServiceChat.OnTyping({chat_id: this.$store.state.rooms.selectedRoomId});
    }, 3000),
    onSubmit({uniq_seq, payload, attachment}) {
      return ServiceChat.OnNew({
        chat_id: this.$store.state.rooms.selectedRoomId,
        uniq_seq,
        message: {payload, attachment},
      });
    },
    submitText() {
      if (this.sending) return;
      this.sending = true;

      if (!this.uniq_seq.length) {
        this.uniq_seq = Date.now() + '-' + Math.random();
      }

      if (this.message.attachment.url.length) {
        const submit = this.onSubmit({
          uniq_seq: this.uniq_seq + '-attachment',
          attachment: {...this.message.attachment},
        });
        if (submit) {
          Object.assign(this.message.attachment, {
            type: 'image',
            url: '',
            url_thumbnail: undefined,
            duration: undefined,
            size: undefined,
          });
        }
      }

      if (this.message.payload.length) {
        const submit = this.onSubmit({
          uniq_seq: this.uniq_seq + '-payload',
          payload: this.message.payload,
        });
        if (submit) {
          this.message.payload = '';
        }
      }

      this.uniq_seq = '';
      this.is_attach_image = false;
      this.sending = false;
    },
    selectAttach(payload) {
      if (!payload) {
        Object.assign(this.message.attachment, {
          type: 'image',
          url: '',
          url_thumbnail: undefined,
          duration: undefined,
          size: undefined,
        });
      } else {
       const {type, attachment} = payload;
        Object.assign(this.message.attachment, {type, ...attachment});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
